import { createTheme } from '@material-ui/core/styles';
import {
  poppinsBold, poppinsLight, poppinsRegular
} from './importFonts';
import { makeStyles } from '@material-ui/core/styles';

export const themeLogin = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#2e2757',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#72727c',
      main: '#b48519',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#fff',
    },
    info: {
      main: '#312a5c',
    },
    titles: {
      main: '#FFFFFF'
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: [
      'PoppinsRegular',
      'PoppinsBold',
      'PoppinsLight'
    ].join(','),
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [ poppinsLight, poppinsBold, poppinsRegular],
      },
    },
    MuiInputBase: {
      root: {
        height: 40,
        borderRadius: 40,
        "& fieldset": {
          borderRadius: 30,
          borderColor: "#cccbd1 !important",

        },
        "&.MuiOutlinedInput-root": {
          borderRadius: 30,
          backgroundColor: "#fff",
        }
      }
    },
    MuiButton: {
      root: {
        height: 40,
        fontWeight: 600,
        borderRadius: 40,
        textTransform: "inherit",
        "&.MuiButton-outlinedSecondary": {
          color: "#b98919"
        },
        "&.MuiButton-contained": {
          boxShadow: "none"
        },
        "&.MuiButton-outlined": {
          borderWidth: 2
        }
      }
    }
  },

});

export const buttonsStyles = makeStyles(theme => ({
  paper: {
    marginTop: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //backgroundColor: "#EEEFF2"
  },
  avatar: {
    margin: 1,
    backgroundColor: 'red',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    //marginTop: 1,
    background: "linear-gradient(to bottom, #f6f6f6, #f4f4f4, #f2f2f2, #f1f0f0, #efeeee, #ebeaea, #e8e6e6, #e4e2e2, #dddbdb, #d6d5d5, #d0cece, #c9c8c8);",
    padding: "1% 6% 6% 6%",
    borderRadius: "5px",
    border: "3px solid #E4E4E4"
  },
  submit: {
    margin: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: 'white',
    backgroundColor: "#6FAC22"
  },
  logo: {
    width: '40%',
    height: '40%'
  },
  banner: {
    width: '100%',
    // height: '40%'
  },
  footer: {
    width: '5%',
    height: '5%'
  },
  button_header: {
    marginTop: 20,
  },
  grid_header: {
    marginTop: 10,
  },
  copyright: {
    justifyContent: 'space-between'
  },
  multilineColor: {
    color: 'red'
  },
  root: {
    background: "red"
  },
  input: {
    color: "white"
  },
  title: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '1.75rem'
  },
  button: {
    fontSize: '0.875rem',
    color: 'white',
    background: 'linear-gradient(0deg, rgba(76,73,74,1) 24%, rgba(124,121,122,1) 68%, rgba(156,156,161,1) 100%)'
  },
  imageBackground: {
    height: '500', width: '800'
  },
  closeButton: {
    // position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  rootTitle: {
    margin: 0,
    padding: theme.spacing(1),
  },
}));

export const backgroundStyles = makeStyles(theme => ({
  certificateBackground: {
    // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/Recurso1.png'})`,
    height: '500px',
    backgroundSize: 'contain',
    width: '690px',
    backgroundRepeat: 'no-repeat'
  },
  fondo: {
    [theme.breakpoints.up('xs')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_movil.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      //height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('sm')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('md')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('lg')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('xl')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },

  },
  fondoSecundario: {
    [theme.breakpoints.up('xs')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_movil.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      //height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('sm')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_secundario.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('md')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_secundario.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('lg')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_secundario.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('xl')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_secundario.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },

  },
  fondoLogin: {
    [theme.breakpoints.up('xs')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_movil.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('sm')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('md')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('lg')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
    [theme.breakpoints.up('xl')]: {
      // backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
      backgroundSize: "100% 100vh",
      width: "100%",
      height: "100vh",
      minWidth: "100%",
      minHeight: "100vh",
      backgroundRepeat: "repeat-y",
      top: "0"
    },
  }
}))

export const containerStyle = makeStyles(theme => ({
  divStandard: {
    padding: "20px",
    border: '2px solid #BEBCC0',

    borderRadius: "8px",
    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)' 
  }
}));
